import { FetchPlanResponse, FetchSinglePlanResponse, GetAllTravelPlansResponse, GetPlanResponse, PlanRequest } from 'Application/models';
import { APICallInstance } from './APICallInstance';
import { AxiosResponse } from 'axios';
import { TravelTypesResponse } from 'Application/models/dto/response/GetTravelTypesResponse';

const planUrl = '/api/v1/plan';

export const createPlan = async (planData: PlanRequest) => {
    try {
        const response: AxiosResponse<GetPlanResponse> = await APICallInstance.post(planUrl, planData);
        console.log(response);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const fetchPlans = async () => {
    const url = `${planUrl}/all`;

    try {
        const response: AxiosResponse<FetchPlanResponse> = await APICallInstance.get(url);
        console.log(response);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const fetchTravelTypes = async (regionName?: string) => {
    const url = `${planUrl}/travel/types`;
    try {
        const response: AxiosResponse<TravelTypesResponse> = await APICallInstance.get(url, {
            params: {
                ...(regionName !== undefined && regionName !== null && { regionName })
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const fetchSinglePlan = async (id: any) => {
    const url = `${planUrl}/${id}`;

    try {
        const response: AxiosResponse<FetchSinglePlanResponse> = await APICallInstance.get(url);
        console.log(response);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const fetchAllPlans = async (regionName: string) => {
    const url = `${planUrl}/all?regionName=${regionName}`;

    try {
        const response: AxiosResponse<GetAllTravelPlansResponse> = await APICallInstance.get(url);
        console.log(response);
        return response.data;
    } catch (error) {
        throw error;
    }
};
